import styled, { css, keyframes } from 'styled-components'
import { colors, sizes } from 'config/ui'
import { Item } from 'components/list/List.styles'

const bg = keyframes`
  from {
    background-position: -300px 0;
  }
  to {
    background-position: 300px 0;
  }
`

const AnimatedBg = css`
  animation: ${bg} 2s linear infinite;
  animation-fill-mode: forwards;
  background: linear-gradient(
    to right,
    #eee,
    ${colors.lightGray} 50%,
    #eee 100%
  );
`

export const StyledBookPlaceholder = styled(Item)`
  ${props => (props.width ? `width: ${props.width};` : '')}
  height: ${props => props.height};
  ${props =>
    props.minHeight ? `min-height: ${props.minHeight} !important;` : ''}
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  ${props =>
    props.responsive
      ? props.responsive
          .map(data => {
            return `
      @media (min-width: ${data.breakpoint}px) {
        width: ${data.width};
        min-height: ${data.minHeight} !important;
      }
    `
          })
          .join('\n')
      : ''}
  
`

export const Cover = styled.div`
  ${AnimatedBg}
  height: ${props => props.height};
  ${props =>
    props.minHeight ? `min-height: ${props.minHeight} !important;` : ''}
  width: 100%;
  border-radius: ${sizes.radius}px;

  ${props =>
    props.responsive
      ? props.responsive
          .map(data => {
            return `
      @media (min-width: ${data.breakpoint}px) {
        min-height: ${data.minHeight} !important;
      }
    `
          })
          .join('\n')
      : ''}

  img {
    width: 100%;
    height: auto;
  }

`

export const Info = styled.div`
  ${({ width }) => css`
    ${AnimatedBg}
    width: ${width};
    height: 14px;
    margin: 7px 0;
    border-radius: ${sizes.radius};
  `};
`
